import { mainConstants } from '../_constants';

const initialState = {
  isOpenSideBar: true,
  routes: null,
  isFetching: false,
  errorMessage: undefined,
  currentPage: 1,
  isPaging: false,
  pages: undefined,
  isMobileScreenSize: false,
  errorModal: null
};

const mainReducer = (state = initialState, action) => {
  switch (action.type) {
    case mainConstants.TOGGLE_SCREEN_SIZE:
      return {
        ...state,
        isMobileScreenSize: !state.isMobileScreenSize
      };
    case mainConstants.TOGGLE_SIDE_BAR:
      return {
        ...state,
        isOpenSideBar: !state.isOpenSideBar
      };
    case mainConstants.TOGGLE_ACTIVE_PAGE:
      return {
        ...state,
        currentPage: action.payload
      };
    case mainConstants.INSERT_ROUTES:
      return {
        ...state,
        routes: action.payload
      };
    case mainConstants.FETCH_ROUTES_START:
      return {
        ...state,
        isFetching: true
      };
    case mainConstants.FETCH_ROUTES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        routes: action.payload
      };
    case mainConstants.FETCH_ROUTES_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload
      };
    case mainConstants.ENABLE_PAGING:
      return {
        ...state,
        isPaging: true
      };
    case mainConstants.DISABLE_PAGING:
      return {
        ...state,
        isPaging: false,
        pages: null
      };
    case mainConstants.INSERT_PAGES:
      return {
        ...state,
        pages: action.payload
      };
    case mainConstants.UPDATE_ERROR_MODAL:
      return {
        ...state,
        errorModal: action.payload
      };
    case mainConstants.CLEAR_ERROR_MODAL:
      return {
        ...state,
        errorModal: null
      };
    default:
      return state;
  }
};

export default mainReducer;
